import React from "react"
import styled from "styled-components"
import { breakpoint } from "../../utils/breakpoint"
import { BackgroundImage, Image } from "react-image-and-background-image-fade"
import { Fade } from "react-reveal"
import title_svg from "../../images/title.svg"
import hero_image from "../../images/hero-image.png"
import report_logo from "../../images/report-logo.png"

const StyledSvgImageWrapper = styled.div`
  width: 38%;
  max-width: 560px;
  margin-left: 19%;
  margin-top: 3%;

  ${breakpoint.md} {
    width: 42%;
    max-width: 760px;
    margin-left: 16%;
    margin-top: 2.8%;
  }

  ${breakpoint.lg} {
    width: 42%;
    max-width: 760px;
    margin-left: 19%;
    margin-top: 2.8%;
  }

  ${breakpoint.xl} {
    width: 42%;
    max-width: 760px;
    margin-left: 16%;
    margin-top: 2.8%;
  }

  ${breakpoint.xxl} {
    width: 47%;
    max-width: 850px;
    margin-left: 17%;
    margin-top: 4.5%;
  }
`

const StyledLogoImageWrapper = styled.div`
  width: 30%;
  max-width: 420px;
  margin-right: 5%;
  margin-top: 2%;

  ${breakpoint.md} {
    width: 27%;
    max-width: 380px;
    margin-right: 8%;
    margin-top: 3.5%;
  }

  ${breakpoint.xl} {
    width: 25%;
    max-width: 400px;
    margin-right: 8%;
    margin-top: 3.5%;
  }

  ${breakpoint.xxl} {
    width: 20%;
    max-width: 400px;
    margin-right: 10%;
    margin-top: 3%;
  }
`

const StyledHeaderLogosWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`

const StyledHeader = styled.header`
  z-index: 3;
  position: relative;
  margin-bottom: 20px;

  ${breakpoint.sm} {
    margin-bottom: 30px;
  }
  ${breakpoint.md} {
    margin-bottom: 70px;
  }
  ${breakpoint.lg} {
    margin-bottom: 130px;
  }
`

const HeaderSection = () => {
  return (
    <StyledHeader>
      <BackgroundImage
        style={{
          backgroundSize: "cover",
          backgroundPosition: "bottom",
          backgroundRepeat: "no-repeat",
        }}
        src={hero_image}
        width="2048px"
        height="1152px"
        isResponsive
      >
        <StyledHeaderLogosWrapper>
          <Fade>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <StyledLogoImageWrapper>
                <Image
                  src={report_logo}
                  width="509px"
                  height="232px"
                  isResponsive
                  disableLoader
                  alt="asia impact report 2020"
                  style={{
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                />
              </StyledLogoImageWrapper>
            </div>
          </Fade>
          <StyledSvgImageWrapper>
            <Fade>
              <Image
                src={title_svg}
                width="384.3px"
                height="222.53px"
                isResponsive
                disableLoader
                alt="journey to impact in asia"
                style={{
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              />
            </Fade>
          </StyledSvgImageWrapper>
        </StyledHeaderLogosWrapper>
      </BackgroundImage>
    </StyledHeader>
  )
}

export default HeaderSection
